import { Component } from '@angular/core';

@Component({
  template: `
    <div>Unauthorized</div>
  `,
  styles: [`
    :host {
      height: 100%;
      display: -ms-flexbox;
      display: flex;
      -ms-flex-align: center;
      align-items: center;
      -ms-flex-pack: center;
      justify-content: center;
    }
  `]
})
export class UnauthorizedComponent {}



// WEBPACK FOOTER //
// ./src/app/layout/unauthorized.component.ts